export const AddressFragment = ({
  address,
}: {
  address: {
    name: string;
    street: string;
    city: string;
    region: string | null;
    postalCode: string;
    country: string;
  };
}) => {
  return (
    <>
      <span className={"select-text"}>{address.name}</span>
      <span className={"select-text"}>{address.street}</span>
      <span className={"select-text"}>{address.city}</span>
      {address.region && (
        <span className={"select-text"}>{address.region}</span>
      )}
      <span className={"select-text"}>{address.postalCode}</span>
      <span className={"select-text"}>{address.country}</span>
    </>
  );
};
